import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-site',
    templateUrl: './site.component.html',
    standalone: false
})
export class SiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
